import { cohortPermissions } from '../constants';

const cohortSharingActions = {
  FETCH_COHORT_MEMBERS: 'FETCH_COHORT_MEMBERS',
  SHOW_COHORT_MEMBERS: 'SHOW_COHORT_MEMBERS',
  SHOW_COHORT_MEMBERS_ERROR: 'SHOW_COHORT_MEMBERS_ERROR',
  SHARE_COHORT: 'SHARE_COHORT',
  UPDATE_SHARE_COHORT_PROPERTIES: 'UPDATE_SHARE_COHORT_PROPERTIES',
  ADD_COHORT_MEMBERS: 'ADD_COHORT_MEMBERS',
  REMOVE_COHORT_MEMBER: 'REMOVE_COHORT_MEMBER',
  UPDATE_COHORT_MEMBER_PERMISSIONS: 'UPDATE_COHORT_MEMBER_PERMISSIONS',
  SHOW_SHARE_COHORT: 'SHOW_SHARE_COHORT',
  HIDE_SHARE_COHORT: 'HIDE_SHARE_COHORT',
  SHARE_COHORT_SUCCESS: 'SHARE_COHORT_SUCCESS',
  SHARE_COHORT_ERROR: 'SHARE_COHORT_ERROR',
  UPDATE_COHORT_MEMBERS_PROPERTIES: 'UPDATE_COHORT_MEMBERS_PROPERTIES',
  UPDATE_CURRENT_COHORT_PERMISSIONS: 'UPDATE_CURRENT_COHORT_PERMISSIONS',
};

export const cohortCreatorPermissions = {
  SECURITY: 'can_manage_perms',
};

export const cohortPermissionGroups = {
  OWNER: Object.values(cohortPermissions),
  EDITOR: [cohortPermissions.UPDATE],
  OBSERVER: [],
};

export const cohortPermissionGroupNames = {
  OWNER: 'OWNER',
  EDITOR: 'EDITOR',
  OBSERVER: 'OBSERVER',
};

export default cohortSharingActions;
